/* =========================================================
   KAIROS BRIDAL
   PREMIUM STICKY ATC — FINAL SUMMARY SYSTEM
   ========================================================= */

(function () {
  "use strict";

  var kairosProductData = null;
  var kairosProductPromise = null;

  function normalizeText(value) {
    return String(value || "")
      .trim()
      .toLocaleLowerCase("tr-TR");
  }

  function getBridalSection() {
    return document.querySelector(
      ".kairos-bridal-main-section"
    );
  }

  function getStickyBars() {
    return Array.from(
      document.querySelectorAll(
        ".kairos-sticky-atc[data-kairos-sticky-atc]"
      )
    );
  }

  function getMainAddButton(section) {
    if (!section) {
      return null;
    }

    return section.querySelector(
      'button[name="add"].product-selector__submit,' +
      '.product-selector__submit[name="add"],' +
      'form[action*="/cart/add"] button[type="submit"]' +
      ':not([data-kairos-sticky-submit])'
    );
  }

  function getMainProductForm(section) {
    var mainButton = getMainAddButton(section);

    if (mainButton) {
      var buttonForm = mainButton.closest(
        'form[action*="/cart/add"]'
      );

      if (buttonForm) {
        return buttonForm;
      }
    }

    return Array.from(
      section.querySelectorAll(
        'form[action*="/cart/add"]'
      )
    ).find(function (form) {
      return !form.closest("[data-kairos-sticky-atc]");
    }) || null;
  }

  function getCurrentVariantId(section) {
    var mainForm = getMainProductForm(section);

    if (mainForm) {
      var variantInput = mainForm.querySelector(
        'input[name="id"]'
      );

      if (variantInput && variantInput.value) {
        return String(variantInput.value);
      }
    }

    var urlVariant = new URL(
      window.location.href
    ).searchParams.get("variant");

    return urlVariant || "";
  }

  function loadProductData() {
    if (kairosProductData) {
      return Promise.resolve(kairosProductData);
    }

    if (kairosProductPromise) {
      return kairosProductPromise;
    }

    var productUrl =
      window.location.pathname.replace(/\/$/, "") + ".js";

    kairosProductPromise = fetch(productUrl, {
      credentials: "same-origin"
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            "Ürün verisi alınamadı: " + response.status
          );
        }

        return response.json();
      })
      .then(function (productData) {
        kairosProductData = productData;
        return productData;
      })
      .catch(function (error) {
        console.warn(
          "Kairos Bridal ürün verisi hatası:",
          error
        );

        return null;
      });

    return kairosProductPromise;
  }

  function getOptionNames(productData) {
    if (
      !productData ||
      !Array.isArray(productData.options)
    ) {
      return [];
    }

    return productData.options.map(function (option) {
      if (typeof option === "string") {
        return option;
      }

      return option && option.name
        ? option.name
        : "";
    });
  }

  function findOptionIndex(productData, type) {
    var optionNames = getOptionNames(productData);

    var matchingIndex = optionNames.findIndex(
      function (optionName) {
        var normalizedName = normalizeText(optionName);

        if (type === "color") {
          return (
            normalizedName.includes("renk") ||
            normalizedName.includes("color") ||
            normalizedName.includes("colour") ||
            normalizedName.includes("altın")
          );
        }

        return (
          normalizedName.includes("beden") ||
          normalizedName.includes("size") ||
          normalizedName.includes("ölçü") ||
          normalizedName.includes("olcu") ||
          normalizedName.includes("yüzük boyu")
        );
      }
    );

    if (matchingIndex !== -1) {
      return matchingIndex;
    }

    /*
     * Bu Bridal ürünlerinde genel sıralama:
     * option1 = renk, option2 = beden.
     */
    return type === "color" ? 0 : 1;
  }

  function formatColorName(value) {
    var normalized = normalizeText(value);

    if (
      normalized.includes("white") ||
      normalized.includes("beyaz")
    ) {
      return "14 Ayar Beyaz Altın";
    }

    if (
      normalized.includes("rose") ||
      normalized.includes("pink") ||
      normalized.includes("pembe")
    ) {
      return "14 Ayar Rose Altın";
    }

    if (
      normalized === "gold" ||
      normalized.includes("yellow") ||
      normalized.includes("sarı") ||
      normalized.includes("sari")
    ) {
      return "14 Ayar Sarı Altın";
    }

    return value
      ? "14 Ayar " + value
      : "14 Ayar Altın";
  }

  function findCurrentVariant(
    productData,
    variantId
  ) {
    if (
      !productData ||
      !Array.isArray(productData.variants)
    ) {
      return null;
    }

    return productData.variants.find(function (variant) {
      return String(variant.id) === String(variantId);
    }) || null;
  }

  function getVariantOptionValue(
    variant,
    optionIndex
  ) {
    if (!variant) {
      return "";
    }

    if (Array.isArray(variant.options)) {
      return variant.options[optionIndex] || "";
    }

    var optionProperty =
      "option" + String(optionIndex + 1);

    return variant[optionProperty] || "";
  }

  function updateStickyVariantId(
    stickyBar,
    variantId
  ) {
    if (!variantId) {
      return;
    }

    stickyBar
      .querySelectorAll(
        'input[name="id"], [data-kairos-variant-id]'
      )
      .forEach(function (input) {
        input.value = variantId;
        input.setAttribute("value", variantId);
      });
  }

  function updateStickySummary(
    stickyBar,
    productData,
    variant
  ) {
    if (!variant) {
      return;
    }

    var colorIndex = findOptionIndex(
      productData,
      "color"
    );

    var sizeIndex = findOptionIndex(
      productData,
      "size"
    );

    var selectedColor = getVariantOptionValue(
      variant,
      colorIndex
    );

    var selectedSize = getVariantOptionValue(
      variant,
      sizeIndex
    );

    var colorTarget = stickyBar.querySelector(
      "[data-kairos-sticky-color]"
    );

    var sizeTarget = stickyBar.querySelector(
      "[data-kairos-sticky-size]"
    );

    if (colorTarget) {
      colorTarget.textContent =
        formatColorName(selectedColor);
    }

    if (sizeTarget) {
      sizeTarget.textContent = selectedSize
        ? "Beden " + selectedSize
        : "Beden seçiniz";
    }

    updateStickyVariantId(
      stickyBar,
      String(variant.id)
    );
  }

  function addBusinessDays(
    startDate,
    businessDays
  ) {
    var result = new Date(startDate);
    var addedDays = 0;

    result.setHours(12, 0, 0, 0);

    while (addedDays < businessDays) {
      result.setDate(result.getDate() + 1);

      var weekday = result.getDay();

      if (weekday !== 0 && weekday !== 6) {
        addedDays += 1;
      }
    }

    return result;
  }

  function formatDate(date) {
    var day = String(date.getDate()).padStart(2, "0");
    var month = String(
      date.getMonth() + 1
    ).padStart(2, "0");

    return (
      day +
      "." +
      month +
      "." +
      String(date.getFullYear())
    );
  }

  function getProductionRange() {
    var deliveryCard = document.querySelector(
      ".kb-bridal-delivery[data-production-time]"
    );

    var productionText = deliveryCard
      ? deliveryCard.getAttribute(
          "data-production-time"
        )
      : "3–5 İş Günü";

    var numbers = String(
      productionText || ""
    ).match(/\d+/g);

    var minimumDays = 3;
    var maximumDays = 5;

    if (numbers && numbers.length > 0) {
      minimumDays = parseInt(numbers[0], 10);

      maximumDays =
        numbers.length > 1
          ? parseInt(numbers[1], 10)
          : minimumDays;
    }

    if (
      !Number.isFinite(minimumDays) ||
      minimumDays < 1
    ) {
      minimumDays = 3;
    }

    if (
      !Number.isFinite(maximumDays) ||
      maximumDays < minimumDays
    ) {
      maximumDays = Math.max(
        minimumDays,
        5
      );
    }

    return {
      min: minimumDays,
      max: maximumDays
    };
  }

  function updateStickyDelivery(stickyBar) {
    var stickyDate = stickyBar.querySelector(
      "[data-kairos-sticky-delivery-date]"
    );

    if (!stickyDate) {
      return;
    }

    var mainDeliveryDate = document.querySelector(
      ".kb-bridal-delivery " +
      "[data-kb-delivery-date]"
    );

    if (
      mainDeliveryDate &&
      mainDeliveryDate.textContent &&
      !mainDeliveryDate.textContent.includes(
        "Hesaplanıyor"
      )
    ) {
      stickyDate.textContent =
        mainDeliveryDate.textContent.trim();

      return;
    }

    var range = getProductionRange();
    var today = new Date();

    var earliestDate = addBusinessDays(
      today,
      range.min
    );

    var latestDate = addBusinessDays(
      today,
      range.max
    );

    var earliestText = formatDate(earliestDate);
    var latestText = formatDate(latestDate);

    stickyDate.textContent =
      earliestText === latestText
        ? earliestText
        : earliestText + " – " + latestText;
  }

  function refreshStickyBar(
    stickyBar,
    section
  ) {
    var variantId = getCurrentVariantId(section);

    updateStickyDelivery(stickyBar);

    if (!variantId) {
      return;
    }

    loadProductData().then(function (productData) {
      if (!productData) {
        return;
      }

      /*
       * Tema hidden input'u henüz değiştirmediyse,
       * URL'deki varyantı ikinci kaynak olarak kontrol et.
       */
      var urlVariantId = new URL(
        window.location.href
      ).searchParams.get("variant");

      var finalVariantId =
        urlVariantId || variantId;

      var currentVariant = findCurrentVariant(
        productData,
        finalVariantId
      );

      if (!currentVariant) {
        currentVariant = findCurrentVariant(
          productData,
          variantId
        );
      }

      updateStickySummary(
        stickyBar,
        productData,
        currentVariant
      );
    });
  }

  function scheduleStickyRefresh(
    stickyBar,
    section
  ) {
    [30, 100, 220, 450, 800].forEach(
      function (delay) {
        window.setTimeout(function () {
          refreshStickyBar(stickyBar, section);
        }, delay);
      }
    );
  }

  function findMainVariantArea(section) {
    var headings = Array.from(
      section.querySelectorAll(
        "label, legend, span, div, p"
      )
    );

    var colorHeading = headings.find(
      function (element) {
        var text = normalizeText(
          element.textContent
        );

        return (
          text === "14 ayar altın rengi" ||
          text === "altın rengi"
        );
      }
    );

    if (colorHeading) {
      return (
        colorHeading.closest(
          "fieldset, product-selector," +
          ".product-selector," +
          ".product-selector__buttons"
        ) ||
        colorHeading.parentElement
      );
    }

    return (
      section.querySelector("product-selector") ||
      section.querySelector(".product-selector")
    );
  }

  function addChangeSelectionLink(
    stickyBar,
    section
  ) {
    if (
      stickyBar.querySelector(
        "[data-kairos-change-selection]"
      )
    ) {
      return;
    }

    var meta = stickyBar.querySelector(
      ".kairos-sticky-atc__meta"
    );

    if (!meta) {
      return;
    }

    var button = document.createElement("button");

    button.type = "button";
    button.className =
      "kairos-sticky-atc__change-selection";

    button.setAttribute(
      "data-kairos-change-selection",
      ""
    );

    button.textContent = "Seçimi Değiştir";

    button.addEventListener(
      "click",
      function () {
        var target = findMainVariantArea(section);

        if (!target) {
          return;
        }

        stickyBar.classList.remove(
          "is-visible"
        );

        target.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });

        target.classList.add(
          "kairos-variant-area--highlight"
        );

        window.setTimeout(function () {
          target.classList.remove(
            "kairos-variant-area--highlight"
          );
        }, 1300);
      }
    );

    meta.insertAdjacentElement(
      "afterend",
      button
    );
  }

  function initializeVisibility(
    stickyBar,
    section
  ) {
    var mainAddButton =
      getMainAddButton(section);

    if (!mainAddButton) {
      return;
    }

    var hasSeenMainButton = false;
    var buttonIsVisible = false;

    var initialRect =
      mainAddButton.getBoundingClientRect();

    /*
     * Sayfa aşağıdaki bir noktadan açılmışsa buton daha önce
     * geçilmiş kabul edilir.
     */
    if (initialRect.bottom < 0) {
      hasSeenMainButton = true;
    }

    function applyVisibility() {
      stickyBar.classList.toggle(
        "is-visible",
        hasSeenMainButton && !buttonIsVisible
      );
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          buttonIsVisible =
            entry.isIntersecting &&
            entry.intersectionRatio > 0;

          if (buttonIsVisible) {
            hasSeenMainButton = true;
          }

          applyVisibility();
        });
      },
      {
        root: null,
        threshold: [0, 0.01, 0.5, 1]
      }
    );

    observer.observe(mainAddButton);

    window.addEventListener(
      "scroll",
      function () {
        var rect =
          mainAddButton.getBoundingClientRect();

        if (
          rect.top < window.innerHeight &&
          rect.bottom > 0
        ) {
          hasSeenMainButton = true;
          buttonIsVisible = true;
        } else {
          buttonIsVisible = false;
        }

        applyVisibility();
      },
      {
        passive: true
      }
    );

    window.addEventListener(
      "resize",
      applyVisibility
    );

    applyVisibility();
  }

  function bindVariantChanges(
    stickyBar,
    section
  ) {
    function handleMainSelection(event) {
      if (
        event.target.closest(
          "[data-kairos-sticky-atc]"
        )
      ) {
        return;
      }

      scheduleStickyRefresh(
        stickyBar,
        section
      );
    }

    section.addEventListener(
      "change",
      handleMainSelection,
      true
    );

    section.addEventListener(
      "input",
      handleMainSelection,
      true
    );

    section.addEventListener(
      "click",
      handleMainSelection,
      true
    );

    window.addEventListener(
      "popstate",
      function () {
        scheduleStickyRefresh(
          stickyBar,
          section
        );
      }
    );
  }

  function initializeStickyBar(
    stickyBar,
    section
  ) {
    addChangeSelectionLink(
      stickyBar,
      section
    );

    refreshStickyBar(
      stickyBar,
      section
    );

    if (
      stickyBar.dataset.kairosFinalReady ===
      "true"
    ) {
      return;
    }

    stickyBar.dataset.kairosFinalReady =
      "true";

    initializeVisibility(
      stickyBar,
      section
    );

    bindVariantChanges(
      stickyBar,
      section
    );

    scheduleStickyRefresh(
      stickyBar,
      section
    );
  }

  function initializeKairosBridal() {
    var section = getBridalSection();

    if (!section) {
      return;
    }

    getStickyBars().forEach(function (
      stickyBar
    ) {
      initializeStickyBar(
        stickyBar,
        section
      );
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeKairosBridal
    );
  } else {
    initializeKairosBridal();
  }

  document.addEventListener(
    "shopify:section:load",
    function () {
      window.setTimeout(
        initializeKairosBridal,
        150
      );
    }
  );
})();

/* =========================================================
   KAIROS BRIDAL — PREMIUM METAL SELECTOR
   Yalnızca Bridal ürün sayfasında çalışır.
   Beden seçimine ve sticky sisteme dokunmaz.
   ========================================================= */

(function () {
  "use strict";

  /*
   * Sayfa ilk açıldığında URL'de özellikle bir varyant verilmişse
   * müşterinin doğrudan seçimini koruruz.
   */
  var hadExplicitVariantOnLoad = new URL(
    window.location.href
  ).searchParams.has("variant");

  var defaultWhiteApplied = false;
  var enhancementTimer = null;

  function normalizeMetalText(value) {
    return String(value || "")
      .trim()
      .toLocaleLowerCase("tr-TR");
  }

  function getMetalType(value) {
    var normalized = normalizeMetalText(value);

    if (
      normalized.includes("white") ||
      normalized.includes("beyaz")
    ) {
      return "white";
    }

    if (
      normalized.includes("rose") ||
      normalized.includes("pink") ||
      normalized.includes("pembe")
    ) {
      return "rose";
    }

    if (
      normalized === "gold" ||
      normalized.includes("yellow") ||
      normalized.includes("sarı") ||
      normalized.includes("sari")
    ) {
      return "yellow";
    }

    return "";
  }

  function getMetalDisplayName(type) {
    if (type === "white") {
      return "Beyaz Altın";
    }

    if (type === "yellow") {
      return "Sarı Altın";
    }

    if (type === "rose") {
      return "Rose Altın";
    }

    return "";
  }

  function getMetalOrder(type) {
    if (type === "white") {
      return 1;
    }

    if (type === "yellow") {
      return 2;
    }

    if (type === "rose") {
      return 3;
    }

    return 10;
  }

  function findBridalMetalFieldset() {
    var bridalSection = document.querySelector(
      ".kairos-bridal-main-section"
    );

    if (!bridalSection) {
      return null;
    }

    var legends = Array.from(
      bridalSection.querySelectorAll("legend")
    );

    var metalLegend = legends.find(function (legend) {
      var text = normalizeMetalText(
        legend.textContent
      );

      return (
        text.includes("14 ayar altın rengi") ||
        text.includes("altın rengi") ||
        text === "renk"
      );
    });

    if (!metalLegend) {
      return null;
    }

    return metalLegend.closest("fieldset");
  }

  function removeEnglishTooltips(element) {
    if (!element) {
      return;
    }

    element.removeAttribute("title");
    element.removeAttribute("data-title");
    element.removeAttribute("data-tooltip");

    element
      .querySelectorAll(
        "[title], [data-title], [data-tooltip]"
      )
      .forEach(function (child) {
        child.removeAttribute("title");
        child.removeAttribute("data-title");
        child.removeAttribute("data-tooltip");
      });
  }

  function enhanceMetalItem(item) {
    var input = item.querySelector(
      'input[type="radio"], input[type="checkbox"]'
    );

    if (!input) {
      return null;
    }

    var metalType = getMetalType(input.value);

    if (!metalType) {
      return null;
    }

    var displayName =
      getMetalDisplayName(metalType);

    item.classList.add(
      "kb-bridal-metal-card"
    );

    item.classList.add(
      "kb-bridal-metal-card--" + metalType
    );

    item.style.order = String(
      getMetalOrder(metalType)
    );

    item.setAttribute(
      "data-kb-metal-type",
      metalType
    );

    removeEnglishTooltips(item);
    removeEnglishTooltips(input);

    var label = item.querySelector("label");

    if (label) {
      removeEnglishTooltips(label);

      label.setAttribute(
        "aria-label",
        displayName + " 14K"
      );
    }

    var existingCopy = item.querySelector(
      ".kb-bridal-metal-card__copy"
    );

    if (!existingCopy) {
      var copy = document.createElement("div");

      copy.className =
        "kb-bridal-metal-card__copy";

      copy.innerHTML =
        '<span class="kb-bridal-metal-card__name">' +
        displayName +
        "</span>" +
        '<span class="kb-bridal-metal-card__karat">14K</span>';

      item.appendChild(copy);
    }

    /*
     * Kartın yazısına veya boş alanına tıklanınca da
     * temanın gerçek radio input'u çalışır.
     */
    if (
      item.dataset.kbMetalClickReady !== "true"
    ) {
      item.dataset.kbMetalClickReady = "true";

      item.addEventListener("click", function (event) {
        if (
          event.target.closest(
            'input, label, a, button'
          )
        ) {
          return;
        }

        if (!input.checked) {
          input.click();
        }
      });
    }

    return {
      item: item,
      input: input,
      type: metalType
    };
  }

  function applyDefaultWhiteMetal(
    enhancedItems
  ) {
    if (
      defaultWhiteApplied ||
      hadExplicitVariantOnLoad
    ) {
      return;
    }

    var whiteMetal = enhancedItems.find(
      function (entry) {
        return entry.type === "white";
      }
    );

    if (!whiteMetal) {
      return;
    }

    /*
     * Sayfa içinde yalnızca bir kez uygularız.
     * MutationObserver yeniden çalışsa bile seçim tekrarlanmaz.
     */
    defaultWhiteApplied = true;

    if (!whiteMetal.input.checked) {
      window.setTimeout(function () {
        whiteMetal.input.click();
      }, 120);
    }
  }

  function enhanceBridalMetalSelector() {
    var fieldset = findBridalMetalFieldset();

    if (!fieldset) {
      return;
    }

    fieldset.classList.add(
      "kb-bridal-metal-picker"
    );

    var list =
      fieldset.querySelector(
        ".product__swatches > ul"
      ) ||
      fieldset.querySelector(
        ".product__swatches ul"
      ) ||
      fieldset.querySelector("ul");

    if (!list) {
      return;
    }

    list.classList.add(
      "kb-bridal-metal-picker__list"
    );

    var enhancedItems = Array.from(
      list.children
    )
      .map(enhanceMetalItem)
      .filter(Boolean);

    if (!enhancedItems.length) {
      return;
    }

    applyDefaultWhiteMetal(enhancedItems);
  }

  function scheduleMetalEnhancement() {
    window.clearTimeout(enhancementTimer);

    enhancementTimer = window.setTimeout(
      enhanceBridalMetalSelector,
      80
    );
  }

  function initializeBridalMetalSelector() {
    enhanceBridalMetalSelector();

    var bridalSection = document.querySelector(
      ".kairos-bridal-main-section"
    );

    if (!bridalSection) {
      return;
    }

    /*
     * Tema varyant değişiminde alanı yeniden oluşturursa
     * premium kart yapısını otomatik olarak geri uygular.
     */
    var observer = new MutationObserver(function (
      mutations
    ) {
      var containsRelevantChange =
        mutations.some(function (mutation) {
          return mutation.addedNodes.length > 0;
        });

      if (containsRelevantChange) {
        scheduleMetalEnhancement();
      }
    });

    observer.observe(bridalSection, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeBridalMetalSelector
    );
  } else {
    initializeBridalMetalSelector();
  }

  document.addEventListener(
    "shopify:section:load",
    function () {
      window.setTimeout(
        initializeBridalMetalSelector,
        150
      );
    }
  );
})();
/* =========================================================
   KAIROS BRIDAL — PREMIUM YÜZÜK İÇİ YAZISI
   ========================================================= */

(function () {
  "use strict";

  function initializeBridalEngraving() {
    document
      .querySelectorAll("[data-kb-bridal-engraving]")
      .forEach(function (engraving) {
        if (engraving.dataset.kbEngravingReady === "true") {
          return;
        }

        engraving.dataset.kbEngravingReady = "true";

        var toggle = engraving.querySelector(
          "[data-kb-engraving-toggle]"
        );

        var content = engraving.querySelector(
          "[data-kb-engraving-content]"
        );

        var input = engraving.querySelector(
          "[data-kb-engraving-input]"
        );

        var counter = engraving.querySelector(
          "[data-kb-engraving-count]"
        );

        var optionalText = engraving.querySelector(
          ".kb-bridal-engraving__optional"
        );

        if (!toggle || !content || !input) {
          return;
        }

        /*
         * Girilen metni gösterecek premium önizleme alanı.
         */
        var preview = engraving.querySelector(
          "[data-kb-engraving-preview]"
        );

        if (!preview) {
          preview = document.createElement("span");
          preview.className =
            "kb-bridal-engraving__preview";
          preview.setAttribute(
            "data-kb-engraving-preview",
            ""
          );

          var heading = engraving.querySelector(
            ".kb-bridal-engraving__heading"
          );

          if (heading) {
            heading.appendChild(preview);
          }
        }

        function getCleanValue() {
          return String(input.value || "").trim();
        }

        function updateEngravingState() {
          var value = getCleanValue();
          var hasValue = value.length > 0;

          if (counter) {
            counter.textContent = String(
              input.value.length
            );
          }

          engraving.classList.toggle(
            "has-value",
            hasValue
          );

          if (optionalText) {
            optionalText.textContent = hasValue
              ? "Eklendi"
              : "İsteğe bağlı";
          }

          if (preview) {
            preview.textContent = hasValue
              ? "“" + value + "”"
              : "";

            preview.hidden = !hasValue;
          }
        }

        function setOpenState(shouldOpen) {
          engraving.classList.toggle(
            "is-open",
            shouldOpen
          );

          toggle.setAttribute(
            "aria-expanded",
            String(shouldOpen)
          );

          content.hidden = !shouldOpen;

          if (shouldOpen) {
            window.setTimeout(function () {
              input.focus();

              input.setSelectionRange(
                input.value.length,
                input.value.length
              );
            }, 100);
          }
        }

        toggle.addEventListener("click", function () {
          var isCurrentlyOpen =
            engraving.classList.contains("is-open");

          setOpenState(!isCurrentlyOpen);
        });

        input.addEventListener(
          "input",
          updateEngravingState
        );

        input.addEventListener("change", function () {
          updateEngravingState();
        });

        /*
         * Enter'a basıldığında form yanlışlıkla gönderilmesin;
         * alan kapanıp giriş kaydedilmiş gibi özet hâline gelsin.
         */
        input.addEventListener("keydown", function (event) {
          if (event.key !== "Enter") {
            return;
          }

          event.preventDefault();
          updateEngravingState();
          setOpenState(false);
          input.blur();
        });

        updateEngravingState();
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeBridalEngraving
    );
  } else {
    initializeBridalEngraving();
  }

  document.addEventListener(
    "shopify:section:load",
    function () {
      window.setTimeout(
        initializeBridalEngraving,
        150
      );
    }
  );
})();
(function () {
  'use strict';

  if (window.__KB_BRIDAL_RING_SIZE_V1__) {
    return;
  }

  window.__KB_BRIDAL_RING_SIZE_V1__ = true;

  var PANEL_OPEN_CLASS = 'kb-ring-size-panel-open';
  var NATIVE_HIDDEN_CLASS = 'kb-ring-size-native--enhanced';
  var SECTION_SELECTOR = 'section.kairos-bridal-main-section';
  var instances = new Map();
  var initTimer = null;

  function normalizeText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLocaleLowerCase('tr-TR');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function makeId(value) {
    return String(value || 'kairos-bridal-product')
      .replace(/[^a-zA-Z0-9_-]/g, '-')
      .replace(/-+/g, '-');
  }

  function getDirectTextNodes(root) {
    var matches = [];
    var walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          var parent = node.parentElement;

          if (!parent) {
            return NodeFilter.FILTER_REJECT;
          }

          if (parent.closest('script, style, template, noscript')) {
            return NodeFilter.FILTER_REJECT;
          }

          var text = normalizeText(node.nodeValue);

          if (
            text === 'beden' ||
            text === 'yüzük ölçüsü' ||
            text === 'yuzuk olcusu'
          ) {
            return NodeFilter.FILTER_ACCEPT;
          }

          return NodeFilter.FILTER_REJECT;
        }
      }
    );

    while (walker.nextNode()) {
      matches.push(walker.currentNode);
    }

    return matches;
  }

  function isMostlyNumericButtons(buttons) {
    if (!buttons.length) {
      return false;
    }

    var numericCount = buttons.filter(function (button) {
      var value = String(button.getAttribute('data-value') || button.textContent || '')
        .replace(',', '.')
        .trim();

      return /^\d+(?:\.\d+)?$/.test(value);
    }).length;

    return numericCount >= Math.max(2, Math.ceil(buttons.length * 0.7));
  }

  function findNativeSizeGroup(section) {
    var labelNodes = getDirectTextNodes(section);

    for (var i = 0; i < labelNodes.length; i += 1) {
      var labelElement = labelNodes[i].parentElement;
      var ancestor = labelElement;
      var depth = 0;

      while (ancestor && ancestor !== section && depth < 9) {
        var lists = Array.from(
          ancestor.querySelectorAll('ul.dropdown__items[data-options], .dropdown__items[data-options]')
        );

        for (var l = 0; l < lists.length; l += 1) {
          var buttons = Array.from(
            lists[l].querySelectorAll('button.dropdown__item-button[data-value]')
          );

          if (buttons.length >= 2 && isMostlyNumericButtons(buttons)) {
            return {
              group: ancestor,
              list: lists[l]
            };
          }
        }

        ancestor = ancestor.parentElement;
        depth += 1;
      }
    }

    var fallbackLists = Array.from(
      section.querySelectorAll('ul.dropdown__items[data-options], .dropdown__items[data-options]')
    );

    for (var j = 0; j < fallbackLists.length; j += 1) {
      var fallbackButtons = Array.from(
        fallbackLists[j].querySelectorAll('button.dropdown__item-button[data-value]')
      );

      if (!isMostlyNumericButtons(fallbackButtons)) {
        continue;
      }

      var fallbackAncestor = fallbackLists[j].parentElement;
      var fallbackDepth = 0;

      while (fallbackAncestor && fallbackAncestor !== section && fallbackDepth < 7) {
        var text = normalizeText(fallbackAncestor.textContent);

        if (text.indexOf('beden') !== -1 || text.indexOf('yüzük ölçüsü') !== -1) {
          return {
            group: fallbackAncestor,
            list: fallbackLists[j]
          };
        }

        fallbackAncestor = fallbackAncestor.parentElement;
        fallbackDepth += 1;
      }
    }

    return null;
  }

  function isNativeButtonUnavailable(button) {
    var item = button.closest('.dropdown__item');
    var classes = [
      'is-disabled',
      'is-unavailable',
      'is-sold-out',
      'unavailable',
      'disabled',
      'sold-out'
    ];

    if (button.disabled || button.getAttribute('aria-disabled') === 'true') {
      return true;
    }

    if (!item) {
      return false;
    }

    return classes.some(function (className) {
      return item.classList.contains(className);
    });
  }

  function readNativeOptions(group) {
    var seen = new Set();
    var buttons = Array.from(
      group.querySelectorAll('button.dropdown__item-button[data-value]')
    );

    return buttons.reduce(function (options, button) {
      var value = String(button.getAttribute('data-value') || button.textContent || '').trim();

      if (!value || seen.has(value)) {
        return options;
      }

      seen.add(value);

      options.push({
        value: value,
        label: String(button.textContent || value).trim(),
        unavailable: isNativeButtonUnavailable(button)
      });

      return options;
    }, []);
  }

  function getSelectedValue(group, fallbackValue) {
    var selectedButton = group.querySelector(
      '.dropdown__item.is-active .dropdown__item-button[data-value], ' +
      '.dropdown__item-button.is-active[data-value], ' +
      '.dropdown__item-button[aria-selected="true"][data-value], ' +
      '.dropdown__item-button[aria-pressed="true"][data-value]'
    );

    if (selectedButton) {
      return String(selectedButton.getAttribute('data-value') || selectedButton.textContent || '').trim();
    }

    return fallbackValue || '';
  }

  function parseSizeNumber(value) {
    var normalized = String(value || '').replace(',', '.').trim();
    var number = Number.parseFloat(normalized);

    return Number.isFinite(number) ? number : null;
  }

  function formatTurkishNumber(value) {
    if (!Number.isFinite(value)) {
      return '—';
    }

    var rounded = Math.round(value * 10) / 10;
    var isWhole = Math.abs(rounded - Math.round(rounded)) < 0.001;

    return (isWhole ? String(Math.round(rounded)) : rounded.toFixed(1)).replace('.', ',');
  }

  function getSizeMetrics(value) {
    var size = parseSizeNumber(value);

    if (size === null) {
      return {
        circumference: '—',
        diameter: '—'
      };
    }

    var circumference = size + 40;
    var diameter = circumference / Math.PI;

    return {
      circumference: formatTurkishNumber(circumference) + ' mm',
      diameter: formatTurkishNumber(diameter) + ' mm'
    };
  }

  function getProductTitle(section) {
    var title = section.querySelector('.product__title, h1');
    return title ? String(title.textContent || '').replace(/\s+/g, ' ').trim() : 'seçtiğim yüzük';
  }

  function getWhatsAppUrl(section) {
    var title = getProductTitle(section);
    var message =
      'Merhaba, “' +
      title +
      '” modeli için yüzük ölçümü konusunda destek almak istiyorum.\n\n' +
      'Ürün bağlantısı: ' +
      window.location.href;

    return 'https://wa.me/905303235479?text=' + encodeURIComponent(message);
  }

  function createCompactSelector(uniqueId, selectedValue) {
    var element = document.createElement('div');
    element.className = 'kb-ring-size';
    element.setAttribute('data-kb-ring-size', '');

    element.innerHTML =
      '<div class="kb-ring-size__bar">' +
        '<span class="kb-ring-size__label">Yüzük Ölçüsü</span>' +
        '<button class="kb-ring-size__guide-button" type="button" data-kb-ring-guide>' +
          'Ölçüm Rehberi' +
        '</button>' +
        '<button class="kb-ring-size__value-button" type="button" ' +
          'data-kb-ring-open aria-haspopup="dialog" aria-controls="' + escapeHtml(uniqueId) + '">' +
          '<span class="kb-ring-size__current" data-kb-ring-current>' +
            escapeHtml(selectedValue) +
          '</span>' +
          '<span class="kb-ring-size__chevron" aria-hidden="true"></span>' +
        '</button>' +
      '</div>';

    return element;
  }

  function getFingerIllustration() {
    return (
      '<svg viewBox="0 0 360 250" aria-hidden="true" focusable="false">' +
        '<g fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">' +
          '<path d="M52 172c35-16 60-46 82-82 8-13 16-22 26-18 10 4 8 18 2 31l-12 27"/>' +
          '<path d="M150 130c13-26 27-58 42-55 12 3 9 20 4 33l-15 39"/>' +
          '<path d="M181 147c13-28 25-50 39-45 11 4 5 22 0 35l-10 27"/>' +
          '<path d="M210 164c11-22 20-37 31-31 9 5 1 22-5 34l-11 20"/>' +
          '<path d="M52 172c45 9 77 20 105 39 24 16 45 23 71 17 22-5 40-20 57-45"/>' +
          '<path d="M118 104c-24 9-41 23-52 43"/>' +
          '<path d="M86 142c32 5 57 17 76 37"/>' +
          '<path d="M78 133c21 3 39 10 55 22" stroke-dasharray="5 7"/>' +
          '<path d="M79 126c-7 8-7 17 0 24"/>' +
          '<path d="M133 150c7-8 7-17 0-24"/>' +
        '</g>' +
      '</svg>'
    );
  }

  function getRingIllustration() {
    return (
      '<svg viewBox="0 0 360 250" aria-hidden="true" focusable="false">' +
        '<g fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">' +
          '<circle cx="180" cy="125" r="77"/>' +
          '<circle cx="180" cy="125" r="62"/>' +
          '<path d="M126 125h108"/>' +
          '<path d="M126 125l13-10M126 125l13 10"/>' +
          '<path d="M234 125l-13-10M234 125l-13 10"/>' +
          '<path d="M147 96c18-14 48-14 66 0" opacity=".35"/>' +
        '</g>' +
      '</svg>'
    );
  }

  function createPanel(uniqueId, section) {
    var panel = document.createElement('div');
    var titleId = uniqueId + '-title';
    var sizeTabId = uniqueId + '-size-tab';
    var guideTabId = uniqueId + '-guide-tab';
    var sizePaneId = uniqueId + '-size-pane';
    var guidePaneId = uniqueId + '-guide-pane';

    panel.className = 'kb-ring-size-panel';
    panel.id = uniqueId;
    panel.setAttribute('data-kb-ring-panel', '');
    panel.setAttribute('aria-hidden', 'true');

    panel.innerHTML =
      '<button class="kb-ring-size-panel__overlay" type="button" ' +
        'data-kb-ring-close tabindex="-1" aria-label="Yüzük ölçüsü panelini kapat"></button>' +
      '<section class="kb-ring-size-panel__dialog" role="dialog" aria-modal="true" ' +
        'aria-labelledby="' + escapeHtml(titleId) + '">' +
        '<header class="kb-ring-size-panel__header">' +
          '<div class="kb-ring-size-panel__top">' +
            '<div class="kb-ring-size-panel__heading-copy">' +
              '<span class="kb-ring-size-panel__eyebrow">Teklif ve Evlilik Yüzükleri</span>' +
              '<h2 class="kb-ring-size-panel__title" id="' + escapeHtml(titleId) + '">' +
                'Yüzük Ölçünüz' +
              '</h2>' +
            '</div>' +
            '<button class="kb-ring-size-panel__close" type="button" ' +
              'data-kb-ring-close aria-label="Paneli kapat"></button>' +
          '</div>' +
          '<div class="kb-ring-size-panel__tabs" role="tablist" aria-label="Yüzük ölçüsü seçenekleri">' +
            '<button class="kb-ring-size-panel__tab is-active" type="button" role="tab" ' +
              'id="' + escapeHtml(sizeTabId) + '" aria-controls="' + escapeHtml(sizePaneId) + '" ' +
              'aria-selected="true" data-kb-ring-tab="sizes">Ölçünüzü Seçin</button>' +
            '<button class="kb-ring-size-panel__tab" type="button" role="tab" ' +
              'id="' + escapeHtml(guideTabId) + '" aria-controls="' + escapeHtml(guidePaneId) + '" ' +
              'aria-selected="false" data-kb-ring-tab="guide">Ölçüm Rehberi</button>' +
          '</div>' +
        '</header>' +
        '<div class="kb-ring-size-panel__body" data-kb-ring-panel-body>' +
          '<div class="kb-ring-size-panel__pane is-active" role="tabpanel" ' +
            'id="' + escapeHtml(sizePaneId) + '" aria-labelledby="' + escapeHtml(sizeTabId) + '" ' +
            'data-kb-ring-pane="sizes">' +
            '<div class="kb-ring-size-panel__intro">' +
              '<h3 class="kb-ring-size-panel__intro-title">Yüzük Ölçünüzü Seçin</h3>' +
              '<p class="kb-ring-size-panel__intro-text">' +
                'Ürününüzün hazırlanacağı en uygun yüzük ölçüsünü seçin. ' +
                'Yalnızca bu modelde sunulan bedenler listelenir.' +
              '</p>' +
            '</div>' +
            '<div class="kb-ring-size-panel__table">' +
              '<div class="kb-ring-size-panel__table-head" aria-hidden="true">' +
                '<span>Yüzük Ölçüsü</span>' +
                '<span>İç Çevre</span>' +
                '<span>İç Çap</span>' +
                '<span>Seçim</span>' +
              '</div>' +
              '<div class="kb-ring-size-panel__options" data-kb-ring-options></div>' +
            '</div>' +
            '<div class="kb-ring-size-panel__support">' +
              '<span class="kb-ring-size-panel__support-eyebrow">Kişisel Destek</span>' +
              '<strong class="kb-ring-size-panel__support-title">Ölçünüzden Emin Değil misiniz?</strong>' +
              '<p class="kb-ring-size-panel__support-text">' +
                'Uzmanımız doğru yüzük ölçüsünü belirlemeniz için size yardımcı olabilir.' +
              '</p>' +
              '<a class="kb-ring-size-panel__support-link" href="' +
                escapeHtml(getWhatsAppUrl(section)) + '" target="_blank" rel="noopener">' +
                '<span>WhatsApp’tan Destek Alın</span>' +
                '<span class="kb-ring-size-panel__support-link-arrow" aria-hidden="true">→</span>' +
              '</a>' +
            '</div>' +
          '</div>' +
          '<div class="kb-ring-size-panel__pane" role="tabpanel" ' +
            'id="' + escapeHtml(guidePaneId) + '" aria-labelledby="' + escapeHtml(guideTabId) + '" ' +
            'data-kb-ring-pane="guide" hidden>' +
            '<div class="kb-ring-size-guide__lead">' +
              '<h3 class="kb-ring-size-guide__title">Yüzük Ölçünüzü Nasıl Alabilirsiniz?</h3>' +
              '<p>' +
                'En doğru sonuç için ölçümü gün sonunda, parmaklarınız normal sıcaklıktayken yapın. ' +
                'İki yöntemden size uygun olanı kullanabilirsiniz.' +
              '</p>' +
            '</div>' +
            '<section class="kb-ring-size-guide__method">' +
              '<div class="kb-ring-size-guide__method-heading">' +
                '<span class="kb-ring-size-guide__method-number">01</span>' +
                '<h4 class="kb-ring-size-guide__method-title">Parmağınızın Çevresini Ölçün</h4>' +
              '</div>' +
              '<div class="kb-ring-size-guide__illustration">' + getFingerIllustration() + '</div>' +
              '<ol class="kb-ring-size-guide__steps">' +
                '<li>Esnemeyen ince bir ip veya dar bir kâğıt şerit hazırlayın.</li>' +
                '<li>Şeridi yüzüğü kullanacağınız parmağa, çok sıkmadan sarın ve birleşme noktasını işaretleyin.</li>' +
                '<li>Şeridi düz zemine açıp işarete kadar olan uzunluğu milimetre olarak ölçün. Bu değer iç çevredir.</li>' +
              '</ol>' +
            '</section>' +
            '<section class="kb-ring-size-guide__method">' +
              '<div class="kb-ring-size-guide__method-heading">' +
                '<span class="kb-ring-size-guide__method-number">02</span>' +
                '<h4 class="kb-ring-size-guide__method-title">Size Uyan Bir Yüzüğü Ölçün</h4>' +
              '</div>' +
              '<div class="kb-ring-size-guide__illustration">' + getRingIllustration() + '</div>' +
              '<ol class="kb-ring-size-guide__steps">' +
                '<li>Aynı parmağa rahatça uyan bir yüzüğü düz bir zemine yerleştirin.</li>' +
                '<li>Yüzüğün içten içe en geniş mesafesini milimetre olarak ölçün. Bu değer iç çaptır.</li>' +
                '<li>Ölçtüğünüz değeri beden tablosundaki en yakın iç çap ile eşleştirin.</li>' +
              '</ol>' +
            '</section>' +
            '<div class="kb-ring-size-guide__notice">' +
              '<strong>Ölçüm Notu</strong>' +
              '<p>' +
                'İki ölçü arasında kalırsanız büyük olan bedeni seçin. ' +
                'Geniş yüzük kollarında bir numara daha büyük ölçü daha rahat olabilir.' +
              '</p>' +
            '</div>' +
            '<div class="kb-ring-size-panel__support">' +
              '<span class="kb-ring-size-panel__support-eyebrow">Kairos Uzman Desteği</span>' +
              '<strong class="kb-ring-size-panel__support-title">Birlikte Doğru Ölçüyü Belirleyelim</strong>' +
              '<p class="kb-ring-size-panel__support-text">' +
                'Ölçüm sonucunuzdan emin değilseniz ürün bağlantısıyla birlikte bize yazabilirsiniz.' +
              '</p>' +
              '<a class="kb-ring-size-panel__support-link" href="' +
                escapeHtml(getWhatsAppUrl(section)) + '" target="_blank" rel="noopener">' +
                '<span>WhatsApp’tan Yardım Alın</span>' +
                '<span class="kb-ring-size-panel__support-link-arrow" aria-hidden="true">→</span>' +
              '</a>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</section>';

    return panel;
  }

  function renderOptions(instance) {
    var options = readNativeOptions(instance.nativeGroup);
    var container = instance.panel.querySelector('[data-kb-ring-options]');

    if (!container || !options.length) {
      return false;
    }

    container.innerHTML = options.map(function (option) {
      var metrics = getSizeMetrics(option.value);
      var unavailableClass = option.unavailable ? ' is-unavailable' : '';
      var disabled = option.unavailable ? ' disabled aria-disabled="true"' : '';

      return (
        '<button class="kb-ring-size-panel__option' + unavailableClass + '" type="button" ' +
          'data-kb-ring-option data-value="' + escapeHtml(option.value) + '"' + disabled + '>' +
          '<span class="kb-ring-size-panel__option-value">' + escapeHtml(option.label) + '</span>' +
          '<span class="kb-ring-size-panel__option-detail">' + escapeHtml(metrics.circumference) + '</span>' +
          '<span class="kb-ring-size-panel__option-detail">' + escapeHtml(metrics.diameter) + '</span>' +
          '<span class="kb-ring-size-panel__option-state" aria-hidden="true"></span>' +
        '</button>'
      );
    }).join('');

    instance.optionSignature = options.map(function (option) {
      return option.value + ':' + (option.unavailable ? '0' : '1');
    }).join('|');

    return true;
  }

  function syncFromNative(instance) {
    if (!instance.nativeGroup.isConnected || !instance.compact.isConnected) {
      scheduleInit();
      return;
    }

    var options = readNativeOptions(instance.nativeGroup);
    var signature = options.map(function (option) {
      return option.value + ':' + (option.unavailable ? '0' : '1');
    }).join('|');

    if (signature && signature !== instance.optionSignature) {
      renderOptions(instance);
    }

    var fallback = options.length ? options[0].value : '';
    var selectedValue = getSelectedValue(instance.nativeGroup, fallback);
    var current = instance.compact.querySelector('[data-kb-ring-current]');

    // The page observer also sees this node. An identical text write would
    // re-trigger initializeAll -> syncFromNative every 80 ms forever.
    if (current && selectedValue && current.textContent !== selectedValue) {
      current.textContent = selectedValue;
    }

    var customOptions = Array.from(
      instance.panel.querySelectorAll('[data-kb-ring-option]')
    );

    customOptions.forEach(function (button) {
      var value = String(button.getAttribute('data-value') || '');
      var nativeButton = Array.from(
        instance.nativeGroup.querySelectorAll('button.dropdown__item-button[data-value]')
      ).find(function (candidate) {
        return String(candidate.getAttribute('data-value') || '') === value;
      });
      var unavailable = !nativeButton || isNativeButtonUnavailable(nativeButton);
      var isSelected = value === selectedValue;

      button.classList.toggle('is-selected', isSelected);
      button.classList.toggle('is-unavailable', unavailable);
      button.disabled = unavailable;
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      button.setAttribute('aria-label', 'Yüzük ölçüsü ' + value + (isSelected ? ', seçili' : ''));
    });

    instance.selectedValue = selectedValue;
  }

  function activateTab(instance, tabName, moveFocus) {
    var tabs = Array.from(instance.panel.querySelectorAll('[data-kb-ring-tab]'));
    var panes = Array.from(instance.panel.querySelectorAll('[data-kb-ring-pane]'));

    tabs.forEach(function (tab) {
      var active = tab.getAttribute('data-kb-ring-tab') === tabName;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });

    panes.forEach(function (pane) {
      var active = pane.getAttribute('data-kb-ring-pane') === tabName;
      pane.classList.toggle('is-active', active);
      pane.hidden = !active;
    });

    var body = instance.panel.querySelector('[data-kb-ring-panel-body]');

    if (body) {
      body.scrollTop = 0;
    }

    instance.activeTab = tabName;

    if (moveFocus) {
      var activeTab = instance.panel.querySelector(
        '[data-kb-ring-tab="' + tabName + '"]'
      );

      if (activeTab) {
        activeTab.focus();
      }
    }
  }

  function getFocusableElements(panel) {
    return Array.from(
      panel.querySelectorAll(
        'button:not([disabled]):not([tabindex="-1"]), ' +
        'a[href], input:not([disabled]), select:not([disabled]), ' +
        'textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      return element.offsetParent !== null && !element.closest('[hidden]');
    });
  }

  function closePanel(instance, restoreFocus) {
    if (!instance.panel.classList.contains('is-open')) {
      return;
    }

    instance.panel.classList.remove('is-open');
    instance.panel.setAttribute('aria-hidden', 'true');
    document.body.classList.remove(PANEL_OPEN_CLASS);

    if (restoreFocus !== false && instance.lastFocused && instance.lastFocused.isConnected) {
      window.setTimeout(function () {
        instance.lastFocused.focus();
      }, 30);
    }
  }

  function openPanel(instance, tabName, opener) {
    syncFromNative(instance);
    activateTab(instance, tabName || 'sizes', false);

    instance.lastFocused = opener || document.activeElement;
    instance.panel.classList.add('is-open');
    instance.panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add(PANEL_OPEN_CLASS);

    window.setTimeout(function () {
      if (tabName === 'guide') {
        var guideTab = instance.panel.querySelector('[data-kb-ring-tab="guide"]');
        if (guideTab) {
          guideTab.focus();
        }
        return;
      }

      var selected = instance.panel.querySelector('[data-kb-ring-option].is-selected:not([disabled])');
      var close = instance.panel.querySelector('.kb-ring-size-panel__close');

      if (selected) {
        selected.focus({ preventScroll: true });
        selected.scrollIntoView({ block: 'center', behavior: 'auto' });
      } else if (close) {
        close.focus();
      }
    }, 80);
  }

  function clickNativeValue(instance, value) {
    var nativeButton = Array.from(
      instance.nativeGroup.querySelectorAll('button.dropdown__item-button[data-value]')
    ).find(function (button) {
      return String(button.getAttribute('data-value') || '') === String(value);
    });

    if (!nativeButton || isNativeButtonUnavailable(nativeButton)) {
      return;
    }

    nativeButton.click();

    window.setTimeout(function () {
      syncFromNative(instance);
      closePanel(instance, true);
    }, 90);
  }

  function bindInstance(instance) {
    var openButton = instance.compact.querySelector('[data-kb-ring-open]');
    var guideButton = instance.compact.querySelector('[data-kb-ring-guide]');

    instance.onOpen = function () {
      openPanel(instance, 'sizes', openButton);
    };

    instance.onGuideOpen = function () {
      openPanel(instance, 'guide', guideButton);
    };

    instance.onPanelClick = function (event) {
      var closeButton = event.target.closest('[data-kb-ring-close]');
      var tab = event.target.closest('[data-kb-ring-tab]');
      var option = event.target.closest('[data-kb-ring-option]');

      if (closeButton) {
        closePanel(instance, true);
        return;
      }

      if (tab) {
        activateTab(instance, tab.getAttribute('data-kb-ring-tab'), false);
        return;
      }

      if (option && !option.disabled) {
        clickNativeValue(instance, option.getAttribute('data-value'));
      }
    };

    instance.onPanelKeydown = function (event) {
      if (!instance.panel.classList.contains('is-open')) {
        return;
      }

      if (event.key === 'Escape') {
        event.preventDefault();
        closePanel(instance, true);
        return;
      }

      if (event.key !== 'Tab') {
        return;
      }

      var focusable = getFocusableElements(instance.panel);

      if (!focusable.length) {
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    instance.onTabKeydown = function (event) {
      var tab = event.target.closest('[data-kb-ring-tab]');

      if (!tab || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) {
        return;
      }

      event.preventDefault();

      var nextTab = tab.getAttribute('data-kb-ring-tab') === 'sizes' ? 'guide' : 'sizes';
      activateTab(instance, nextTab, true);
    };

    openButton.addEventListener('click', instance.onOpen);
    guideButton.addEventListener('click', instance.onGuideOpen);
    instance.panel.addEventListener('click', instance.onPanelClick);
    instance.panel.addEventListener('keydown', instance.onPanelKeydown);
    instance.panel.addEventListener('keydown', instance.onTabKeydown);

    var syncQueued = false;

    instance.nativeObserver = new MutationObserver(function () {
      if (syncQueued) {
        return;
      }

      syncQueued = true;

      window.requestAnimationFrame(function () {
        syncQueued = false;
        syncFromNative(instance);
      });
    });

    instance.nativeObserver.observe(instance.nativeGroup, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'disabled', 'aria-disabled', 'aria-selected', 'aria-pressed', 'data-value']
    });
  }

  function destroyInstance(section, instance) {
    if (!instance) {
      return;
    }

    if (instance.nativeObserver) {
      instance.nativeObserver.disconnect();
    }

    if (instance.compact && instance.compact.isConnected) {
      instance.compact.remove();
    }

    if (instance.panel && instance.panel.isConnected) {
      instance.panel.remove();
    }

    if (instance.nativeGroup) {
      instance.nativeGroup.classList.remove(NATIVE_HIDDEN_CLASS);
      instance.nativeGroup.removeAttribute('data-kb-ring-native');
    }

    document.body.classList.remove(PANEL_OPEN_CLASS);
    instances.delete(section);
  }

  function initializeSection(section) {
    var existing = instances.get(section);

    if (
      existing &&
      existing.nativeGroup.isConnected &&
      existing.compact.isConnected &&
      existing.panel.isConnected
    ) {
      syncFromNative(existing);
      return;
    }

    if (existing) {
      destroyInstance(section, existing);
    }

    var native = findNativeSizeGroup(section);

    if (!native || native.group.hasAttribute('data-kb-ring-native')) {
      return;
    }

    var nativeGroupText = normalizeText(native.group.textContent);

    /* Güvenlik: yanlışlıkla metal kartlarının tamamını asla gizleme. */
    if (
      nativeGroupText.indexOf('14 ayar altın rengi') !== -1 ||
      (nativeGroupText.indexOf('beyaz altın') !== -1 &&
        nativeGroupText.indexOf('sarı altın') !== -1)
    ) {
      return;
    }

    var options = readNativeOptions(native.group);

    if (options.length < 2) {
      return;
    }

    var initialValue = getSelectedValue(native.group, options[0].value);
    var uniqueId = 'kb-ring-size-panel-' + makeId(section.id || Date.now());
    var compact = createCompactSelector(uniqueId, initialValue);
    var panel = createPanel(uniqueId, section);
    var instance = {
      section: section,
      nativeGroup: native.group,
      nativeList: native.list,
      compact: compact,
      panel: panel,
      selectedValue: initialValue,
      optionSignature: '',
      activeTab: 'sizes',
      lastFocused: null,
      nativeObserver: null
    };

    try {
      native.group.parentNode.insertBefore(compact, native.group);
      document.body.appendChild(panel);

      if (!renderOptions(instance)) {
        throw new Error('Yüzük ölçüsü seçenekleri oluşturulamadı.');
      }

      bindInstance(instance);
      syncFromNative(instance);

      native.group.setAttribute('data-kb-ring-native', '');
      native.group.classList.add(NATIVE_HIDDEN_CLASS);
      instances.set(section, instance);
    } catch (error) {
      if (compact.isConnected) {
        compact.remove();
      }

      if (panel.isConnected) {
        panel.remove();
      }

      native.group.classList.remove(NATIVE_HIDDEN_CLASS);
      native.group.removeAttribute('data-kb-ring-native');
    }
  }

  function initializeAll(root) {
    Array.from(instances.entries()).forEach(function (entry) {
      var section = entry[0];
      var instance = entry[1];

      if (!section.isConnected || !instance.nativeGroup.isConnected) {
        destroyInstance(section, instance);
      }
    });

    var scope = root && root.querySelectorAll ? root : document;
    var sections = [];

    if (scope.matches && scope.matches(SECTION_SELECTOR)) {
      sections.push(scope);
    }

    sections = sections.concat(Array.from(scope.querySelectorAll(SECTION_SELECTOR)));

    sections.forEach(function (section) {
      initializeSection(section);
    });
  }

  function scheduleInit(root) {
    window.clearTimeout(initTimer);
    initTimer = window.setTimeout(function () {
      initializeAll(root || document);
    }, 80);
  }

  function start() {
    initializeAll(document);

    var pageObserver = new MutationObserver(function (mutations) {
      var needsInit = mutations.some(function (mutation) {
        return mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0;
      });

      if (needsInit) {
        scheduleInit(document);
      }
    });

    pageObserver.observe(document.body, {
      subtree: true,
      childList: true
    });

    document.addEventListener('shopify:section:load', function (event) {
      scheduleInit(event.target);
    });

    document.addEventListener('shopify:section:reorder', function () {
      scheduleInit(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

/* =========================================================
   KAIROS — PREMIUM ACCORDION AÇILIŞ / KAPANIŞ
   Yalnızca Bridal detay alanlarında çalışır
   ========================================================= */

(function () {
  const ACCORDION_SELECTOR = [
    ".kairos-bridal-main-section .kb-gia-certificate details",
    ".kairos-bridal-main-section .kb-bridal-specs details"
  ].join(",");

  const DURATION = 320;
  const EASING = "cubic-bezier(0.22, 1, 0.36, 1)";

  function clearAnimationStyles(details) {
    details.style.height = "";
    details.style.overflow = "";
    details.style.willChange = "";
    details.removeAttribute("data-kb-animating");
  }

  function closeAccordion(details, summary) {
    const startHeight = details.offsetHeight;
    const endHeight = summary.offsetHeight;

    details.setAttribute("data-kb-animating", "true");
    details.style.overflow = "hidden";
    details.style.willChange = "height";

    const animation = details.animate(
      [
        { height: `${startHeight}px`, opacity: 1 },
        { height: `${endHeight}px`, opacity: 0.98 }
      ],
      {
        duration: DURATION,
        easing: EASING
      }
    );

    animation.onfinish = function () {
      details.open = false;
      clearAnimationStyles(details);
    };

    animation.oncancel = function () {
      clearAnimationStyles(details);
    };
  }

  function openAccordion(details, summary) {
    const startHeight = summary.offsetHeight;

    details.setAttribute("data-kb-animating", "true");
    details.style.height = `${startHeight}px`;
    details.style.overflow = "hidden";
    details.style.willChange = "height";
    details.open = true;

    requestAnimationFrame(function () {
      const endHeight = details.scrollHeight;

      const animation = details.animate(
        [
          { height: `${startHeight}px`, opacity: 0.98 },
          { height: `${endHeight}px`, opacity: 1 }
        ],
        {
          duration: DURATION,
          easing: EASING
        }
      );

      animation.onfinish = function () {
        clearAnimationStyles(details);
      };

      animation.oncancel = function () {
        clearAnimationStyles(details);
      };
    });
  }

  function initializePremiumAccordions(scope) {
    const root = scope || document;
    const accordions = root.querySelectorAll(ACCORDION_SELECTOR);

    accordions.forEach(function (details) {
      if (details.hasAttribute("data-kb-accordion-ready")) {
        return;
      }

      const summary = details.querySelector(":scope > summary");

      if (!summary) {
        return;
      }

      details.setAttribute("data-kb-accordion-ready", "true");

      summary.addEventListener("click", function (event) {
        event.preventDefault();

        if (details.hasAttribute("data-kb-animating")) {
          return;
        }

        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
          details.open = !details.open;
          return;
        }

        if (details.open) {
          closeAccordion(details, summary);
        } else {
          openAccordion(details, summary);
        }
      });
    });
  }

  function startPremiumAccordions() {
    initializePremiumAccordions(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      startPremiumAccordions
    );
  } else {
    startPremiumAccordions();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initializePremiumAccordions(event.target);
  });
})();
